module.exports = __webpack_public_path__ + "static/media/us.pictogram.ad86d05b.svg";